<template>
    <div class="app organ-selector" v-if="visible">
        <app-header class="app-header" :title="title" :hideNavIcon="true" @go-back="handleBackEvent">
        </app-header>
        <van-search
                style="border-bottom: 1px solid #ddd"
                shape="round"
                background="#fff"
                clearable
                v-model="searchKey"
                placeholder="请输入自寄网点名称或地址">
            <div slot="left-icon" class="search-slot">
                <div class="search-slot__area" @click="handleAreaEvent">
                    <span style="padding: 0 0.25rem;">{{city.districtName}}</span>
                    <van-icon style="display: inline-block;transform: rotate(90deg);" name="play" color="#000"
                              size="55rpx"></van-icon>
                </div>
                <van-icon style="display: inline-block;" name="search" color="#f99231" size="48rpx"></van-icon>
            </div>
        </van-search>
        <div class="order-tabs-list">
            <van-pull-refresh
                    v-model="loading"
                    style="padding-bottom: 1.7rem;box-sizing: border-box;"
                    @refresh="onRefresh">
                <div class="no-list" v-if="list.length === 0">暂无数据</div>
                <organ-card
                        @on-click-item="handleSelectItem(item)"
                        v-for="item in dataList"
                        :key="item.organId"
                        :item="item"/>
            </van-pull-refresh>
        </div>
        <!-- 省市区组件 -->
        <district-picker v-model="city" :visible.sync="districtShow" @on-select="getList"></district-picker>
    </div>
</template>

<script>
    import {Dialog} from "vant"

    export default {
        name: "OrganList",
        components: {
            OrganCard: () => import('./OrganCard'),
            AppHeader: () => import('@/components/common/header/Header'),
            districtPicker: () => import('@/views/address/components/DistrictPicker')
        },
        data() {
            return {
                searchKey: '',
                districtShow: false,
                city: {
                    provinceName: '',
                    provinceId: '',
                    cityName: '',
                    cityId: '',
                    districtName: '',
                    districtId: ''
                },
                loading: false,
                finished: false,
                list: []
            }
        },
        props: {
            value: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            visible: {
                type: Boolean,
                default: false
            },
            title: {
                type: String,
                default: "附近网点"
            },
            jurisdiction: {
                type: Boolean,
                default: false
            },
            orderNumber: {
                type: String,
                default: ""
            }
        },
        watch: {
            visible(val) {
                if (val) {
                    Object.keys(this.city).forEach(key => {
                        this.city[key] = this.value[key]
                    })
                    this.getList()
                }
            },
            /*value: {
                handler(val) {
                    Object.keys(this.city).forEach(key => {
                        this.city[key] = val[key]
                    })
                },
                deep: true
            }*/
        },

        computed: {
            dataList() {
                let _search = this.searchKey;
                if (_search) {
                    //不区分大小写处理
                    let reg = new RegExp(_search, 'ig')
                    return this.list.filter((item) => {
                        return item.address.match(reg) || item.phone.match(reg) || item.organName.match(reg)
                    })
                }
                return this.list
            }
        },
        methods: {
            onLoad() {
                //this.getList()
            },
            onRefresh() {
                this.getList()
            },
            handleBackEvent() {
                Object.keys(this.city).forEach(key => {
                    if (this.city[key]) {
                        this.city[key] = ''
                    }
                })
                this.searchKey = ''
                this.$emit('input', this.value)
                this.$emit('update:visible', false)
            },
            handleAreaEvent() {
                this.districtShow = true
            },
            handleSelectItem(item) {
                if (this.$route.name === 'PushOrderDetail' && this.jurisdiction) {
                    console.log(item)
                    /**
                     * 派单操作
                     * */
                    Dialog.confirm({
                        title: "温馨提示",
                        message: "是否确定分配至" + item.organName + "？"
                    }).then(() => {
                        let params = {
                            params: {
                                orderNumbers: [this.orderNumber],
                                organId: item.organId
                            }
                        }
                        this.$axios.post("merchant/dispatchOrgan", params).then(res => {
                            this.handleBackEvent()
                            this.$toast('分配网点成功');
                        })
                    }).catch((err) => {
                        return false
                    })

                } else {
                    Object.keys(this.city).forEach(key => {
                        if (this.city[key]) {
                            this.city[key] = ''
                        }
                    })
                    this.searchKey = ''
                    let val = Object.assign({}, this.value, this.city)
                    val.organId = item.organId
                    val.organName = item.organName
                    this.$emit('input', val)
                    this.$emit('update:visible', false)
                }
            },
            getList() {
                this.loading = true
                let params = {
                    params: Object.assign({}, this.value, this.city)
                }
                if (params.params.cityId == '441900' || params.params.cityId == '442000') {
                    params.params.districtId = ""
                }
                params.params.address = this.city.provinceName + this.city.cityName + this.city.districtName + this.value.address
                params.params.logisticsCompanyId = this.$logisticsCompanyId
                this.$axios.post('logistics/company/getAreaOrganList', params).then(res => {
                    this.list = res.data.data
                }).finally(() => {
                    this.loading = false
                })
            }
        }
    }
</script>

<style lang="scss">
    .organ-selector {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 99;
        height: 100%;
        overflow: hidden;
        background-color: white;
    }

    .search-slot {
        display: flex;
        align-items: center;

        &__area {
            border-right: 1px solid #ddd;
            padding: 0 0.25rem;
            margin-right: 0.25rem;
            display: flex;
            align-items: center;
        }
    }

    .van-search .van-cell {
        display: flex;
        align-items: center;
    }

    .no-list {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        font-size: 0.4rem;
        color: #8F8F8F;
    }

    .order-tabs-list {
        height: 100%;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        flex: 1;
        box-sizing: border-box;
    }
</style>
